function mapError(error) {
    if (error.data) {
        // Old style error
        return {
            type: error.type,
            message: error.data.errorMessage,
            code: error.data.errorCode,
        }
    } else {
        return {
            type: error.code,
            message: error.type,
            code: error.message,
        }
    }
}

export function parseError(e) {
    let error = mapError(e)
    if (error.type === 'chargeError') {
        return chargeError(error)
    } else {
        return 'error_' + error.type
    }
}

function chargeError({ code }) {
    // See https://pages.github.schibsted.io/spt/cc-docs/payment/guides/error-handling/#list-of-error-codes
    // See morgenlevering/source/js/controllers/checkoutController.js
    switch (code) {
        case '1702': // User is not connected with client. User didn't agree on clients agreement.
            return 'error_chargeError_termsNotAccepted'
        case '2201': // Encrypted card details from Adyen is not valid any more
            return 'error_chargeError_timeout'
        case '2209': // The card used for the transaction has expired
            return 'error_chargeError_cardExpired'
        case '5301': // Invalid or missing card number
            return 'error_chargeError_invalidCardNumber'
        case '5302': // Invalid or missing cvc on card
        case '5305': // Invalid or missing cvc on card
            return 'error_chargeError_invalidCVC'
        case '5303': // Invalid or missing card holder name
            return 'error_chargeError_invalidCardHolderName'
        case '5304': // Invalid expiry date on card
            return 'error_chargeError_invalidExpirationDate'
        case '1201': // Credit card not verified. Error code returned when trying to initialize order/payment involving Payex and when chosen Payex payment method (credit card) is not verified.
        case '1202': // Credit card not found. Error code returned when trying to initialize order/payment involving Payex and when chosen Payex payment method (credit card) is not found.
        case '1203': // Customer’s bank declined the transaction. Error code returned when PayEx responded with code \“PaymentRefusedByFinancialInstitution\” Payment failed because it was rejected financial institution.
        case '1204': // Credit card operation canceled by customer. Error code returned when PayEx responded with code \“OperationCancelledbyCustomer\” Customer canceled operation.
        case '1205': // Customer’s card is not eligible for this kind of purchase. Error code returned when PayEx responded with code \“CardNotEligible\” See http://www.payexpim.com/technical-reference/return-codes/
        case '1206': // Customer’s bank declined the transaction. Error code returned when PayEx responded with code \“REJECTED_BY_ACQUIRER\” See http://www.payexpim.com/technical-reference/return-codes/
        case '1207': // Some problem occurred with the credit card. Error code returned when PayEx responded with code \“CreditCard_Error\” See http://www.payexpim.com/technical-reference/return-codes/
        case '1208': // Bank rejected due to suspected duplicate request. Error code returned when PayEx responded with code \“Access_DuplicateRequest\” See http://www.payexpim.com/technical-reference/return-codes/
        case '1213': // Credit card is not accepted for this purchase. Credit card was rejected by payment service provider.
        case '1231': // Balance exceeds limits
        case '1232': // Insufficient funds
        case '1233': // No money on account
        case '1234': // Balance exceded
        case '1235': // Fraud pattern deteced
        case '1500': // Payment method not found
        case '1501': // Unauthorized access to payment method
        case '1502': // Given payment method couldn’t be verified
        case '2202': // Possible fraud detected
        case '2204': // Insufficient funds
        case '2205': // The card used for the transaction is blocked
        case '2207': // The transaction was refused
        case '2210': // The shopper’s bank does not support or does not allow this type of transaction
        case '5001': // Payment method is not found
        case '5002': // Payment method is not verified
        case '5003': // Payment method data supplied is not valid. Payment method is not verified
            return 'error_chargeError_paymentRejected'
        default:
            return 'error_chargeError_unknown'
    }
}
